import React, { useState } from 'react'

const Card = (props) => {
  const [modal, setModal] = useState(false)

  const toggleModal = () => {
    setModal(!modal)
  }

  if (modal) {
    document.body.classList.add('active-modal')
  } else {
    document.body.classList.remove('active-modal')
  }
  return (
    <>
      <div className='box btn_shadow '>
        <div className='img'>
          <img src={props.image} alt='' onClick={toggleModal} />
        </div>
        <div className='category d_flex'>
          <div>
            <span onClick={toggleModal}>{props.category}</span> <br />
          </div>
          <label>
            <i className='far fa-heart'></i> {props.totalLike}
          </label>
        </div>
        <div className='title'>
          <h2 onClick={toggleModal}>{props.title}</h2>
          <a href='#popup' className='arrow' onClick={toggleModal}>
            <i class='fas fa-arrow-right'></i>
          </a>
        </div>
      </div>

      {/* Popup box */}
      {modal && (
        <div className='modal'>
          <div onClick={toggleModal} className='overlay'></div>
          <div className='modal-content d_flex'>
            <div className='modal-img left'>
              <img src={props.image} alt='' />
            </div>
            <div className='modal-text right'>
              <span>{props.category}</span>
              <h1>{props.title}</h1>

              <p>{props.desc}</p>

              <h3 style={{ marginBottom: '10px' }}>Responsible</h3>
              <ul style={{ marginBottom: '30px' }}>
                {props?.responsible?.map((items, index) => {
                  return (
                    <>
                      <li key={index}>> {items}</li>
                    </>
                  )
                })}
              </ul>
              <h3 style={{ marginBottom: '10px' }}>Technologies</h3>
              <p>
                {props?.tech?.map((m) => (
                  <img src={m} alt='icon' className='icon-tech' />
                ))}
              </p>
              <div className='button f_flex mtop'>
                <button id='btn-detail' className='btn_shadow'>
                  LIKE THIS <i class='far fa-thumbs-up'></i>
                </button>
                <a
                  href={props?.link}
                  target='_blank'
                  id='btn-detail'
                  className='btn_shadow'
                  rel='noreferrer'
                >
                  PROJECT<i class='fas fa-chevron-right'></i>
                </a>
              </div>
              <button className='close-modal btn_shadow' onClick={toggleModal}>
                <i class='fas fa-times'></i>
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default Card
